import Icon from './Icon'

// https://linearicons.com/free

const ApartmentIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M14 6h1v1h-1v-1z" />
      <path d="M14 8h1v1h-1v-1z" />
      <path d="M14 10h1v1h-1v-1z" />
      <path d="M14 12h1v1h-1v-1z" />
      <path d="M14 16h1v1h-1v-1z" />
      <path d="M14 14h1v1h-1v-1z" />
      <path d="M6 6h1v1h-1v-1z" />
      <path d="M6 8h1v1h-1v-1z" />
      <path d="M6 10h1v1h-1v-1z" />
      <path d="M6 12h1v1h-1v-1z" />
      <path d="M6 16h1v1h-1v-1z" />
      <path d="M6 14h1v1h-1v-1z" />
      <path d="M4 6h1v1h-1v-1z" />
      <path d="M4 8h1v1h-1v-1z" />
      <path d="M4 10h1v1h-1v-1z" />
      <path d="M4 12h1v1h-1v-1z" />
      <path d="M4 16h1v1h-1v-1z" />
      <path d="M4 14h1v1h-1v-1z" />
      <path d="M8 6h1v1h-1v-1z" />
      <path d="M8 8h1v1h-1v-1z" />
      <path d="M8 10h1v1h-1v-1z" />
      <path d="M8 12h1v1h-1v-1z" />
      <path d="M8 16h1v1h-1v-1z" />
      <path d="M8 14h1v1h-1v-1z" />
      <path d="M18.5 19h-0.5v-13.5c0-0.763-0.567-1.549-1.291-1.791l-4.709-1.57v-1.64c0-0.158-0.075-0.307-0.202-0.401s-0.291-0.123-0.442-0.078l-9.042 2.713c-0.737 0.221-1.314 0.997-1.314 1.766v14.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h18c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5zM16.393 4.658c0.318 0.106 0.607 0.507 0.607 0.842v13.5h-5v-15.806l4.393 1.464zM2 4.5c0-0.329 0.287-0.714 0.602-0.808l8.398-2.52v17.828h-9v-14.5z" />
    </Icon>
  )
}

const ArrowDownIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z" />
    </Icon>
  )
}

const ArrowUpIcon = (props) => {
  return (
    <Icon height={24} width={24} {...props}>
      <path d="M9.146 0.646l-6 6c-0.195 0.195-0.195 0.512 0 0.707s0.512 0.195 0.707 0l5.146-5.146v16.293c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-16.293l5.146 5.146c0.195 0.195 0.512 0.195 0.707 0 0.098-0.098 0.146-0.226 0.146-0.354s-0.049-0.256-0.146-0.354l-6-6c-0.195-0.195-0.512-0.195-0.707 0z" />
    </Icon>
  )
}

const CalendarIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M18.5 2h-2.5v-0.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0.5h-10v-0.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0.5h-2.5c-0.827 0-1.5 0.673-1.5 1.5v14c0 0.827 0.673 1.5 1.5 1.5h17c0.827 0 1.5-0.673 1.5-1.5v-14c0-0.827-0.673-1.5-1.5-1.5zM1.5 3h2.5v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h10v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h2.5c0.276 0 0.5 0.224 0.5 0.5v2.5h-18v-2.5c0-0.276 0.224-0.5 0.5-0.5zM18.5 18h-17c-0.276 0-0.5-0.224-0.5-0.5v-10.5h18v10.5c0 0.276-0.224 0.5-0.5 0.5z" />
      <path d="M7.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M10.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M13.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M16.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M4.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M7.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M10.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M13.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M16.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M4.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M7.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M10.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M13.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M16.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M4.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M7.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M10.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M13.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M16.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
    </Icon>
  )
}

const CheckmarkCircleIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M9.5 20c-2.538 0-4.923-0.988-6.718-2.782s-2.782-4.18-2.782-6.717c0-2.538 0.988-4.923 2.782-6.718s4.18-2.783 6.718-2.783c2.538 0 4.923 0.988 6.718 2.783s2.782 4.18 2.782 6.718-0.988 4.923-2.782 6.717c-1.794 1.794-4.18 2.782-6.718 2.782zM9.5 2c-4.687 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5-3.813-8.5-8.5-8.5z" />
      <path d="M7.5 14.5c-0.128 0-0.256-0.049-0.354-0.146l-3-3c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l2.646 2.646 6.646-6.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-7 7c-0.098 0.098-0.226 0.146-0.354 0.146z" />
    </Icon>
  )
}

const ChevronDownIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M0 6c0-0.128 0.049-0.256 0.146-0.354 0.195-0.195 0.512-0.195 0.707 0l8.646 8.646 8.646-8.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-9 9c-0.195 0.195-0.512 0.195-0.707 0l-9-9c-0.098-0.098-0.146-0.226-0.146-0.354z" />
    </Icon>
  )
}

const ChevronLeftIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M11.5,17c0.13,0,0.26-0.05,0.35-0.15c0.2-0.2,0.2-0.51,0-0.71L6.21,10.5l5.65-5.65c0.2-0.2,0.2-0.51,0-0.71 s-0.51-0.2-0.71,0l-6,6c-0.2,0.2-0.2,0.51,0,0.71l6,6C11.24,16.95,11.37,17,11.5,17z" />
    </Icon>
  )
}

const ChevronSmallLeftIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M11.4 17.9c.1 0 .3 0 .4-.1.2-.2.2-.5 0-.7l-6-6.5 6-5.6c.2-.2.2-.5 0-.7-.3-.3-.6-.3-.8-.2l-6.4 6c-.2.2-.2.5 0 .7l6.4 6.9c.1.1.2.2.4.2z" />
    </Icon>
  )
}

const ChevronRightIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M5 20c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l8.646-8.646-8.646-8.646c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l9 9c0.195 0.195 0.195 0.512 0 0.707l-9 9c-0.098 0.098-0.226 0.146-0.354 0.146z" />
    </Icon>
  )
}

const ChevronSmallRightIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M8.5,17c-0.13,0-0.26-0.05-0.35-0.15c-0.2-0.2-0.2-0.51,0-0.71l5.65-5.65L8.15,4.85c-0.2-0.2-0.2-0.51,0-0.71 s0.51-0.2,0.71,0l6,6c0.2,0.2,0.2,0.51,0,0.71l-6,6C8.76,16.95,8.63,17,8.5,17z" />
    </Icon>
  )
}

const ChevronUpIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M0 15c0 0.128 0.049 0.256 0.146 0.354 0.195 0.195 0.512 0.195 0.707 0l8.646-8.646 8.646 8.646c0.195 0.195 0.512 0.195 0.707 0s0.195-0.512 0-0.707l-9-9c-0.195-0.195-0.512-0.195-0.707 0l-9 9c-0.098 0.098-0.146 0.226-0.146 0.354z" />
    </Icon>
  )
}

const CrossIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M10.707 10.5l5.646-5.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.646 5.646-5.646-5.646c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.646 5.646-5.646 5.646c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l5.646-5.646 5.646 5.646c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-5.646-5.646z" />
    </Icon>
  )
}

const FileIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M17.854 5.646l-4.5-4.5c-0.094-0.094-0.221-0.146-0.354-0.146h-9.5c-0.827 0-1.5 0.673-1.5 1.5v16c0 0.827 0.673 1.5 1.5 1.5h13c0.827 0 1.5-0.673 1.5-1.5v-12.5c0-0.133-0.053-0.26-0.146-0.354zM16.793 6h-3.293c-0.276 0-0.5-0.224-0.5-0.5v-3.293l3.793 3.793zM17 18.5c0 0.276-0.224 0.5-0.5 0.5h-13c-0.276 0-0.5-0.224-0.5-0.5v-16c0-0.276 0.224-0.5 0.5-0.5h8.5v3.5c0 0.827 0.673 1.5 1.5 1.5h3.5v11.5z" />
    </Icon>
  )
}

const InfoCircleIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M16.2,3.8C14.4,2,12,1,9.5,1S4.6,2,2.8,3.8S0,8,0,10.5s1,4.9,2.8,6.7S7,20,9.5,20s4.9-1,6.7-2.8S19,13,19,10.5S18,5.6,16.2,3.8z M9.5,19C4.8,19,1,15.2,1,10.5S4.8,2,9.5,2S18,5.8,18,10.5S14.2,19,9.5,19z" />
      <path d="M9.5,15C9.2,15,9,14.8,9,14.5v-10C9,4.2,9.2,4,9.5,4S10,4.2,10,4.5v10C10,14.8,9.8,15,9.5,15z" />
      <path d="M9.5,18C9.2,18,9,17.8,9,17.5v-1C9,16.2,9.2,16,9.5,16s0.5,0.2,0.5,0.5v1C10,17.8,9.8,18,9.5,18z" />
    </Icon>
  )
}

const MenuIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M17.5 6h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h15c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M17.5 11h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h15c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
      <path d="M17.5 16h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h15c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" />
    </Icon>
  )
}

const PageFirstIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M4.55,17L4.55,17c0.28,0,0.5-0.22,0.5-0.5l0-12c0-0.28-0.22-0.5-0.5-0.5h0c-0.28,0-0.5,0.22-0.5,0.5v12 C4.05,16.78,4.27,17,4.55,17z" />
      <path d="M12.5,17c0.13,0,0.26-0.05,0.35-0.15c0.2-0.2,0.2-0.51,0-0.71L7.21,10.5l5.65-5.65c0.2-0.2,0.2-0.51,0-0.71 s-0.51-0.2-0.71,0l-6,6c-0.2,0.2-0.2,0.51,0,0.71l6,6C12.24,16.95,12.37,17,12.5,17z" />
    </Icon>
  )
}

const PageLastIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M14.45,17L14.45,17c-0.28,0-0.5-0.22-0.5-0.5v-12c0-0.28,0.22-0.5,0.5-0.5h0c0.28,0,0.5,0.22,0.5,0.5v12 C14.95,16.78,14.73,17,14.45,17z" />
      <path d="M6.5,17c-0.13,0-0.26-0.05-0.35-0.15c-0.2-0.2-0.2-0.51,0-0.71l5.65-5.65L6.15,4.85c-0.2-0.2-0.2-0.51,0-0.71 s0.51-0.2,0.71,0l6,6c0.2,0.2,0.2,0.51,0,0.71l-6,6C6.76,16.95,6.63,17,6.5,17z" />
    </Icon>
  )
}

const PlusIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M15.5,10H10V4.5C10,4.22,9.78,4,9.5,4S9,4.22,9,4.5V10H3.5C3.22,10,3,10.22,3,10.5S3.22,11,3.5,11H9v5.5 C9,16.78,9.22,17,9.5,17s0.5-0.22,0.5-0.5V11h5.5c0.28,0,0.5-0.22,0.5-0.5S15.78,10,15.5,10z" />
    </Icon>
  )
}
const ApproveIcon = (props) => {
  return (
    <svg
      width="71"
      height="70"
      viewBox="0 0 71 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="70" height="70" rx="35" fill="#E8F2D2" />
      <path
        d="M28.8327 19.9992C26.9917 19.9992 25.4993 21.4916 25.4993 23.3326V46.6659C25.4993 48.5068 26.9917 49.9992 28.8327 49.9992H35.4993V41.6665C35.4993 40.7461 36.2455 39.9999 37.1659 39.9998L45.4993 39.9993V23.3326C45.4993 21.4916 44.007 19.9992 42.166 19.9992H41.2853C41.2804 19.9996 41.2525 20.0034 41.199 20.0314C41.1296 20.0678 41.04 20.1341 40.9489 20.2345C40.0464 21.2289 38.2607 22.6507 35.4993 22.6507C32.738 22.6507 30.9523 21.2289 30.0498 20.2345C29.9587 20.1341 29.8691 20.0678 29.7997 20.0314C29.7462 20.0034 29.7183 19.9996 29.7134 19.9992H28.8327ZM45.3326 43.3327L38.8327 43.3331V49.8325C42.0979 49.1697 44.6698 46.5978 45.3326 43.3327ZM22.166 23.3326C22.166 19.6507 25.1508 16.6659 28.8327 16.6659H29.714C30.9379 16.6659 31.9108 17.3251 32.5182 17.9944C33.0353 18.5641 33.9911 19.3174 35.4993 19.3174C37.0076 19.3174 37.9634 18.5641 38.4805 17.9944C39.0879 17.3251 40.0608 16.6659 41.2847 16.6659H42.166C45.8479 16.6659 48.8327 19.6507 48.8327 23.3326V41.6659C48.8327 48.1092 43.6093 53.3326 37.166 53.3326H28.8327C25.1508 53.3326 22.166 50.3478 22.166 46.6659V23.3326ZM28.8327 28.3326C28.8327 27.4121 29.5789 26.6659 30.4993 26.6659H40.4993C41.4198 26.6659 42.166 27.4121 42.166 28.3326C42.166 29.253 41.4198 29.9992 40.4993 29.9992H30.4993C29.5789 29.9992 28.8327 29.253 28.8327 28.3326ZM28.8327 34.9992C28.8327 34.0788 29.5789 33.3326 30.4993 33.3326H37.166C38.0865 33.3326 38.8327 34.0788 38.8327 34.9992C38.8327 35.9197 38.0865 36.6659 37.166 36.6659H30.4993C29.5789 36.6659 28.8327 35.9197 28.8327 34.9992Z"
        fill="#0A893D"
      />
    </svg>
  )
}

const PenIcon = (props) => {
  return (
    <svg
      width="71"
      height="70"
      viewBox="0 0 71 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="70" height="70" rx="35" fill="#E8F2D2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.6237 20.5425C45.7843 19.7031 44.4233 19.7031 43.5839 20.5425L41.3891 22.7373L44.4289 25.7772L46.6237 23.5823C47.4631 22.7429 47.4631 21.3819 46.6237 20.5425ZM42.0718 28.1342L39.032 25.0944L26.3225 37.804L24.8025 42.3637L29.3623 40.8438L42.0718 28.1342ZM37.8266 21.5858L23.6872 35.7251C23.5043 35.9081 23.3664 36.1311 23.2846 36.3766L20.5862 44.4719C20.3865 45.0707 20.5424 45.731 20.9888 46.1774C21.4352 46.6238 22.0955 46.7797 22.6944 46.58L30.7896 43.8816C31.0351 43.7998 31.2581 43.662 31.4411 43.479L48.9807 25.9393C51.1219 23.7981 51.1219 20.3266 48.9808 18.1855C46.8396 16.0443 43.3681 16.0443 41.2269 18.1855L37.8805 21.5319C37.8713 21.5406 37.8622 21.5495 37.8532 21.5585C37.8442 21.5675 37.8353 21.5766 37.8266 21.5858ZM18.834 49.9989C18.834 49.0784 19.5802 48.3322 20.5007 48.3322L50.5007 48.3322C51.4211 48.3322 52.1673 49.0784 52.1673 49.9989C52.1673 50.9194 51.4211 51.6656 50.5007 51.6656L20.5007 51.6656C19.5802 51.6656 18.834 50.9194 18.834 49.9989Z"
        fill="#0A893D"
      />
    </svg>
  )
}

const CheckMark = (props) => {
  return (
     <svg
      width="71"
      height="70"
      viewBox="0 0 71 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="70" height="70" rx="35" fill="#E8F2D2" />
      <path
        d="M50.0112 25.4873C50.6621 26.1382 50.6621 27.1934 50.0112 27.8443L33.3445 44.511C32.6937 45.1619 31.6384 45.1619 30.9875 44.511L22.6542 36.1777C22.0033 35.5268 22.0033 34.4715 22.6542 33.8206C23.305 33.1698 24.3603 33.1698 25.0112 33.8206L32.166 40.9755L47.6542 25.4873C48.305 24.8364 49.3603 24.8364 50.0112 25.4873Z"
        fill="#0A893D"
      />
    </svg>


  )
}


const CommentsIcon = (props) => {
  return (
    <Icon {...props}>
      <path
        stroke="null"
        d="m21.31221,0.29917l-18.5967,0c-1.40054,0 -2.53591,1.12481 -2.53591,2.51236l0,13.39926c0,1.38753 1.13536,2.51236 2.53591,2.51236l3.00084,0l-0.45983,4.09513c-0.05127,0.45973 0.28335,0.87353 0.7474,0.92432c0.23962,0.0262 0.47915,-0.0502 0.65835,-0.20996l5.3947,-4.8095l9.25524,0c1.40054,0 2.53591,-1.12481 2.53591,-2.51236l0,-13.39926c0,-1.38753 -1.13536,-2.51236 -2.53591,-2.51236l-0.00001,0l0.00001,0zm0.84527,15.9116c0,0.46253 -0.37846,0.83747 -0.84532,0.83747l-9.5798,0c-0.20887,0.00005 -0.4103,0.07674 -0.56553,0.21522l-3.98475,3.55331l0.31867,-2.83813c0.05181,-0.45964 -0.28227,-0.87388 -0.74626,-0.92525c-0.03121,-0.00344 -0.06255,-0.0052 -0.09396,-0.00515l-3.94502,0c-0.46686,0 -0.84532,-0.37494 -0.84532,-0.83747l0,-13.39926c0,-0.46253 0.37846,-0.83747 0.84532,-0.83747l18.5967,0c0.46686,0 0.84532,0.37494 0.84532,0.83747l0,13.39926l-0.00005,0l0.00001,0z"
        fill="#04a928"
      />
    </Icon>
  )
}

const UserIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M9.5 11c-3.033 0-5.5-2.467-5.5-5.5s2.467-5.5 5.5-5.5 5.5 2.467 5.5 5.5-2.467 5.5-5.5 5.5zM9.5 1c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5c2.481 0 4.5-2.019 4.5-4.5s-2.019-4.5-4.5-4.5z" />
      <path d="M17.5 20h-16c-0.827 0-1.5-0.673-1.5-1.5 0-0.068 0.014-1.685 1.225-3.3 0.705-0.94 1.67-1.687 2.869-2.219 1.464-0.651 3.283-0.981 5.406-0.981s3.942 0.33 5.406 0.981c1.199 0.533 2.164 1.279 2.869 2.219 1.211 1.615 1.225 3.232 1.225 3.3 0 0.827-0.673 1.5-1.5 1.5zM9.5 13c-3.487 0-6.060 0.953-7.441 2.756-1.035 1.351-1.058 2.732-1.059 2.746 0 0.274 0.224 0.498 0.5 0.498h16c0.276 0 0.5-0.224 0.5-0.5-0-0.012-0.023-1.393-1.059-2.744-1.382-1.803-3.955-2.756-7.441-2.756z" />
    </Icon>
  )
}

const WarningIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M18.5 19h-18c-0.178 0-0.342-0.094-0.432-0.248s-0.091-0.343-0.004-0.498l9-16c0.089-0.157 0.255-0.255 0.436-0.255s0.347 0.097 0.436 0.255l9 16c0.087 0.155 0.085 0.344-0.004 0.498s-0.254 0.248-0.432 0.248zM1.355 18h16.29l-8.145-14.48-8.145 14.48z" />
      <path d="M9.5 14c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v5c0 0.276-0.224 0.5-0.5 0.5z" />
      <path d="M9.5 17c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" />
    </Icon>
  )
}

const SyncIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M19.854 8.646c-0.195-0.195-0.512-0.195-0.707 0l-1.149 1.149c-0.051-2.060-0.878-3.99-2.341-5.452-1.511-1.511-3.52-2.343-5.657-2.343-2.974 0-5.686 1.635-7.077 4.266-0.129 0.244-0.036 0.547 0.208 0.676s0.547 0.036 0.676-0.208c1.217-2.303 3.59-3.734 6.193-3.734 3.789 0 6.885 3.027 6.997 6.789l-1.143-1.143c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l2 2c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l2-2c0.195-0.195 0.195-0.512 0-0.707z" />
      <path d="M16.869 13.058c-0.244-0.129-0.547-0.036-0.676 0.208-1.217 2.303-3.59 3.734-6.193 3.734-3.789 0-6.885-3.027-6.997-6.789l1.143 1.143c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-2-2c-0.195-0.195-0.512-0.195-0.707 0l-2 2c-0.195 0.195-0.195 0.512 0 0.707s0.512 0.195 0.707 0l1.149-1.149c0.051 2.060 0.878 3.99 2.341 5.452 1.511 1.511 3.52 2.343 5.657 2.343 2.974 0 5.686-1.635 7.077-4.266 0.129-0.244 0.036-0.547-0.208-0.676z" />
    </Icon>
  )
}

const FullscreenIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" />
    </Icon>
  )
}

const DownloadIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
    </Icon>
  )
}

const AddIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
    </Icon>
  )
}

const RemoveIcon = (props) => {
  return (
    <Icon {...props}>
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 13H5v-2h14v2z" />
    </Icon>
  )
}

export const IconTablerCopyPlus = ({
  height = '1em',
  strokeWidth = '2',
  fill = 'none',
  focusable = 'false',
  ...props
}: Omit<React.SVGProps<SVGSVGElement>, 'children'>) => (
  <svg
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height={height}
    focusable={focusable}
    {...props}
  >
    <g
      fill={fill}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
    >
      <path d="M7 9.667A2.667 2.667 0 0 1 9.667 7h8.666A2.667 2.667 0 0 1 21 9.667v8.666A2.667 2.667 0 0 1 18.333 21H9.667A2.667 2.667 0 0 1 7 18.333z" />
      <path d="M4.012 16.737A2 2 0 0 1 3 15V5c0-1.1.9-2 2-2h10c.75 0 1.158.385 1.5 1M11 14h6m-3-3v6" />
    </g>
  </svg>
)


export {
  CheckMark,
  ApproveIcon,
  PenIcon,
  ApartmentIcon,
  ArrowDownIcon,
  ArrowUpIcon,
  CalendarIcon,
  CheckmarkCircleIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronSmallLeftIcon,
  ChevronRightIcon,
  ChevronSmallRightIcon,
  ChevronUpIcon,
  CrossIcon,
  FileIcon,
  PageFirstIcon,
  PageLastIcon,
  InfoCircleIcon,
  MenuIcon,
  PlusIcon,
  CommentsIcon,
  UserIcon,
  WarningIcon,
  SyncIcon,
  FullscreenIcon,
  DownloadIcon,
  AddIcon,
  RemoveIcon,
}
